import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

/** 연관품의 변경이력 모달 styled (list/배치/reconnect 칩 영역). */

export const HistoryListRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const HistoryBatchRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

/** 배치 헤더 row — 모바일 세로 스택 / PC 가로 space-between */
export const HistoryBatchHeader = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;

  @media (min-width: 576px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
`;

export const HistoryBatchMessage = styled('span')`
  flex: 1 1 auto;
  min-width: 0;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--dk-text, #000);
  word-break: keep-all;
`;

// time: 모바일 좌측정렬 전체폭, PC 우측정렬 width140.
export const HistoryBatchTime = styled('span')`
  flex-shrink: 0;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--dk-text-dim, #b7bbc2);

  @media (min-width: 576px) {
    width: 140px;
    text-align: right;
  }
`;

// 항목 행 자체는 공통 RelatedItemRow(layout='inline') 가 담당. 여기선 leading 아이콘만 제공.
export const HistoryItemIcon = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  color: var(--dk-text-secondary, #888d96);

  & > svg {
    width: 24px;
    height: 24px;
  }
`;

// reconnect 묶음: ↳ 아이콘(칩 밖·앞) + "다시 연결" 보더 칩.
export const ReconnectRow = styled('span')`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

// ↳ 아이콘 — 칩 밖 선행. 14×14, 회색.
export const ReconnectArrow = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  color: var(--dk-text-secondary, #888d96);

  & > svg {
    width: 14px;
    height: 14px;
  }
`;

/** "다시 연결" Chip14 — 보더+텍스트만 (아이콘은 ReconnectArrow 로 칩 밖에 분리). */
export const ReconnectChipButton = styled('button')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px 10px;
  border: 1px solid var(--dk-line, #e7e9ec);
  border-radius: 4px;
  background-color: var(--dk-bg, #fff);
  color: var(--dk-text-strong, #5f636b);
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 120ms ease, border-color 120ms ease;

  &:hover:not(:disabled) {
    background-color: var(--dk-bg-subtle, #fafafa);
    border-color: var(--dk-line-strong, #d4d7dc);
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:focus-visible {
    outline: 2px solid #000;
    outline-offset: 2px;
  }
`;

/** 빈 이력 + 로딩 placeholder 공용 컨테이너. */
export const HistoryFallback = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 32px 16px;
  font-family: Pretendard, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--dk-text-dim, #b7bbc2);
`;
